<template>
  <div>
    <SectionHeader header="ID Check" image="uiw-font-person" :active="makeHeaderActive" />

    <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded" v-if="enable">
      <IDVerifLanding v-if="showIDScanLanding" @onIDScanPassed="onIDScanPassed" />
      <IDVerifForm v-else @onSubmitNext="onSubmitNext" @onRedo="onRedo" />
    </div>
  </div>
</template>

<script>
import SectionHeader from '@/components/Atoms/SectionHeader';
import IDVerifForm from './IDVerifForm.vue';
import IDVerifLanding from './IDVerifLanding.vue';

export default {
  name: 'CalculatorIdentityVerification',
  components: { SectionHeader, IDVerifLanding, IDVerifForm },
  props: ['makeHeaderActive', 'enable'],
  computed: {},
  created() {},
  data: function () {
    return {
      showIDScanLanding: true
    };
  },
  methods: {
    onSubmitNext: async function () {
      setTimeout(() => {
        this.$emit('identityVerificationCreated');
      });
    },
    onRedo: function () {
      this.showIDScanLanding = true;
      this.$router.go();
    },
    onIDScanPassed: function () {
      this.showIDScanLanding = false;
    }
  }
};
</script>
